import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider }  from './context/AuthContext.jsx';
import { AppProvider }   from './context/AppContext.jsx';
import Layout from './components/layout/Layout.jsx';

const Home          = lazy(() => import('./pages/home/Home.jsx'));
const Services      = lazy(() => import('./pages/services/Services.jsx'));
const ServiceDetail = lazy(() => import('./pages/services/ServiceDetail.jsx'));
const Login         = lazy(() => import('./pages/auth/Login.jsx'));
const Onboarding    = lazy(() => import('./pages/onboarding/Onboarding.jsx'));
const Bookings      = lazy(() => import('./pages/bookings/Bookings.jsx'));
const Profile       = lazy(() => import('./pages/profile/Profile.jsx'));
const Notifications = lazy(() => import('./pages/profile/Notifications.jsx'));
const NotFound      = lazy(() => import('./pages/NotFound.jsx'));

function Loader() {
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'50vh', gap:14 }}>
      <div style={{ width:44, height:44, borderRadius:'50%', border:'3px solid #F4F4F5', borderTopColor:'#E8380D', animation:'spin .7s linear infinite' }} />
      <p style={{ fontSize:13, color:'#A1A1AA', fontFamily:'Nunito,sans-serif', fontWeight:700 }}>Loading…</p>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

export default function App() {
  return (
    <div className="shell">
      <BrowserRouter>
        <AppProvider>
          <AuthProvider>
            <Toaster
              position="top-center"
              gutter={8}
              toastOptions={{
                duration: 3000,
                style: {
                  fontFamily: 'Nunito, sans-serif',
                  fontSize: 14,
                  fontWeight: 700,
                  borderRadius: 14,
                  boxShadow: '0 8px 32px rgba(0,0,0,.15)',
                  padding: '12px 16px',
                  maxWidth: 340,
                },
                success: { iconTheme: { primary: '#10B981', secondary: '#fff' } },
                error:   { iconTheme: { primary: '#EF4444', secondary: '#fff' } },
              }}
            />
            <Suspense fallback={<Loader />}>
              <Routes>
                {/* Auth pages — no bottom nav */}
                <Route path="/login"       element={<Login />} />
                <Route path="/onboarding"  element={<Onboarding />} />

                {/* Main app — with bottom nav */}
                <Route element={<Layout />}>
                  <Route index                    element={<Home />} />
                  <Route path="/services"         element={<Services />} />
                  <Route path="/services/:id"     element={<ServiceDetail />} />
                  <Route path="/bookings"         element={<Bookings />} />
                  <Route path="/profile"          element={<Profile />} />
                  <Route path="/notifications"    element={<Notifications />} />
                  <Route path="*"                 element={<NotFound />} />
                </Route>
              </Routes>
            </Suspense>
          </AuthProvider>
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}
